import BaseFeature from '../../foundation/base/base';
import { Swiper } from '../../../node_modules/swiper';
import { Navigation, Autoplay } from '../../../node_modules/swiper/modules';

class SwiperHero extends BaseFeature {
	constructor(element) {
		super(element);
		this.el = element;
		this.loop = element.dataset.hsloop === 'true';
		this.autoplay = element.dataset.hsautoplay;
		this.autoplaydelay = Number(element.dataset.hsautoplaydelay);

		this.initialize();
	}

	initialize() {
		const swiperSettings = {
			modules: [Navigation, Autoplay],
			loop: this.loop,

			// If we need pagination
			// pagination: {
			// 	el: '.swiper-pagination',
			// },

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},

			// And if we need scrollbar
			scrollbar: {
				el: '.swiper-scrollbar',
			}
		};
		if (this.autoplay === 'true') {
			swiperSettings.autoplay = { delay: this.autoplaydelay, disableOnInteraction: true };
		}
		// eslint-disable-next-line no-unused-vars
		const swiper = new Swiper('.swiper', swiperSettings);
	}
}

export default SwiperHero;
